import { Injectable } from '@angular/core';



@Injectable()
export class MensajesConstantes {
    public static _servicioNoDisponible = 'Servicio no disponible por el momento';
    public static _noHayResultados = 'No hay resultados que mostrar';

 // ===================== CONSTANTES PARA ETIQUETAS, LABELS, PLACEHOLDERS  ======================================//
   
    //__________________________________________________________________________________________________//
    //BOTONES ETIQUETAS

    public _Actualizar: string = 'ACTUALIZAR';
    public _Aceptar: string = 'ACEPTAR';
    public _Anterior: string = 'ANTERIOR';
    public _Anular: string = 'ANULAR';
    public _Asignar: string = 'ASIGNAR';
    public _Agregar: string = 'AGREGAR';
    public _Buscar: string = 'BUSCAR';
    public _Cancelar: string = 'CANCELAR';
    public _Comprobante: string = 'COMPROBANTE';
    public _Consultar: string = 'CONSULTAR';
    public _Descargar: string = 'DESCARGAR';
    public _Editar: string = 'EDITAR';
    public _Exportar: string = 'EXPORTAR';
    public _Eliminar: string = 'ELIMINAR'; 
    public _Guardar: string = 'GUARDAR';
    public _Grabar: string = 'GRABAR';
    public _Generar: string = 'GENERAR';
    public _Informacion: string = 'INFORMACIÓN';
    public _Limpiar: string = 'LIMPIAR';
    public _Seleccionar: string = 'SELECCIONAR';
    public _Ficha: string = 'FICHA';
    public _Volver: string = 'REGRESAR';
    public _Continuar: string = 'CONTINUAR';
    public _ContinuarSinReserva: string = 'CONTINUAR SIN RESERVA';
    public _Ver: string = 'Ver';
    public _Imprimir = 'IMPRIMIR';
    public _Horario = 'HORARIO';
    public _Horarios = 'HORARIOS';
    public _Finalizar = 'FINALIZAR';
    public _Ofertar: string = 'OFERTAR';
    public _Temas: string = 'TEMAS';
    public _Grupos: string = 'GRUPOS';
    public _Resumen: string = 'RESUMEN';
    public _Quitar: string = 'QUITAR';
    public _Pagar: string = 'PAGAR';
    public _Papeleta: string = 'PAGAR';
    public _Facturar: string = 'FACTURAR';
    public _Siguiente: string = 'SIGUIENTE';
    public _Desactivar: string ='DESACTIVAR';
    public _Activar: string ='ACTIVAR';
    //__________________________________________________________________________________________________//
    //CABECERAS PLACEHOLDERS COMBOS
    // tslint:disable-next-line:no-inferrable-types
    public _placeHolderAccesibilidadDiscapacitados: string = 'Seleccione un tipo de accesibilidad de discapacitados';
    public _placeholderCarrera: string = 'Seleccione una carrera';
    public _placeholderCampus: string = 'Seleccione un campus';
    public _placeHolderFacultad: string = 'Seleccione una facultad';
    public _placeHolderModalidadEstudio: string = 'Seleccione una modalidad de estudio';
    public _placeHolderNivelFormacion: string = 'Seleccione un nivel de formación';
    public _placeHolderUnidadOrganizacional: string = 'Seleccione una unidad organizacional';
    public _placeHolderUnidad: string = 'Seleccione una unidad';
    public _placeHolderEstructuraCurricular: string = 'Seleccione una estructura curricular';
    public _placeHolderPeriodo: string = 'Seleccione un periodo';
    public _placeHolderEstadoAprobacion: string = 'Seleccione un estado de aprobacion';
    public _placeHolderFuncionalidad: string = 'Seleccione una funcionalidad';
    public _placeHolderRegistro: string = 'Seleccione un registro';
    public _placeholderConfiguracionCalificacion: string = 'Seleccione una Configuración de Calificación';
    public _placeholderDetalleCalificacion = 'Seleccione un Detalle de Calificación';
    public _placeholderParametro: string = 'Seleccione un parámetro';
    public _placeHolderDocente: string = 'Seleccione un Docente';
    public _placeHolderCategoriaParametro: string = 'Seleccione una categoría de parámetro';
    public _placeHolderTema: string = 'Seleccione un Tema';
    public _placeHolderOferta: string = 'Seleccione una Oferta';
    public _placeHolderTipoTema: string = 'Seleccione un tipo de tema';
    public _placeHolderTipoUnidad: string = 'Seleccione un tipo de unidad';
    public _placeHoldertipoMatriculasParametro: string = 'Seleccione un tipo de matrícula';
    public _placeHolderClasificacion: string = 'Seleccione una Clasificacion';
    public _placeHolderTipoOtroServicio: string = 'Seleccione el Tipo de Servicio';
    public _placeHolderTipoParametro: string = 'Seleccione el Tipo de Parámetro';
    public _placeHolderTipo: string = 'Seleccione un Tipo';
    public _placeHolderTipoPeriodo: string = 'Seleccione un tipo de periodo';
    public _placeHolderCategoriaProducto: string = 'Seleccione una Categoría de Producto';
    public _placeHolderModalidadEmpleo: string = 'Seleccione una modalidad de empleo';
    public _placeHolderEstadoEmpleado: string = 'Seleccione un estado del empleado';    
    public _placeHolderFormatoFechaCalendario: string = 'dd-mm-aaaa';    
    public _placeHolderProceso = 'Seleccione un proceso';
    public _placeHolderAnioPosgrado = 'Seleccione el año en el que se va a matricular';


    /***************************************** ************************* */

    /********************************************************************************************* */

    /******************Mensajes de Toolpi */
    public _aprobarTodaPlanificacion='APROBAR TODA LA PLANIFICACIÓN';
    public _enviarTodaPlanificacion='ENVIAR TODA LA PLANIFICACIÓN'
    public _verRequerimientosIngresados='VER SERVICIOS INGRESADOS';
    public _debeSeleccinarRegistro='Debe seleccionar un registro';
  
    /************* */
    public _alertaLimiteProduccion='ALERTA, LÍMITE DE PRODUCCIÓN DIARIA EXCEDIDA';
    public _eliminarPlanificacion='ELIMINAR PLANIFICACIÓN';
    public _accion = 'Acción';
    public _agregarRequerimientos='Agregar requerimientos';
    public _aprobar_noaprobar='Aprobar / no_aprobar';
    public _aprobarTodo = 'APROBAR TODO';
    public _almacenamiento='Almacenamiento';
    public _cantidadPorcion='Cantidad de Porciones';
    public _complementoFicha='Complemento Ficha';
    public _desperdicio='Desperdicio';

    public _pesoPreparacion='Peso de Preparación';
    public _pesoPorcion='Peso de porción';
    public _partida='Partida';
    public _pesoPlato='Peso del Plato';
    public _dificultad='Dificultad';
    public _tiempoPreparacion='Tiempo de Preparación';
    public _tipoFicha='Tipo Ficha';
    public _materiaPrima='Materia Prima';
    public _unidadMedida='Unidad Medida';
    public _cantidadBruta='Cantidad Bruta';
    public _rendimiento='Rendimiento';
    public _cantidadNeta='Cantidad Neta';
    public _pasos='Paso';
    public _fichaEstandar='Ficha estándar';
    public _ficha='Ficha';
    public _multiplicador='Multiplicador';
    public _quitar ='Quitar';
    public _valorMultiplicador='Valor Multiplicador';

    

    public _confirmar_cancelar='Confirmar / Cancelar';
    public _costo='costo ($)';
    public _costoTotal= 'Costo Total';
    public _costoAprobado='Costo Total Aprobado';
    public _verRequerimientos='Ver requerimientos';
    public _crearFichaDisponibilidadPlanificacion ='Nueva Fecha disponible para planificación';
    public _crearPlanificacion='Crear Planificación';
    public _devolver='DEVOLVER';
    public _editarFichaDisponibilidadPlanificacion ='Editar Fecha disponible para planificación';
    public _enviarTodo='ENVIAR PARA APROBACIÓN';
    public _tituloDisponibilidadPlanificacionListar= 'Listado de fechas disponibles para planificación de servicio de prácticas prepropresionales'
    public _tituloDetalle='Detalle de Disponibilidad Excepcional';
    public _tituloCrearDisponibilidadExcepcional='Nueva fecha Disponibilidad Excepcional';
    public _tituloListadoDisponibilidadExcepcional='Registro de Fechas para excepcionalidades';
    public _tituloEliminarDisponibilidad='Eliminación de fecha para disponibilidad de planificación';
    public _tituloPlanificacion='Planificación Servicio de Prácticas Preprofesionales';
    public _tituloCrearPlanificacion='Crear Planificación de Servicio de Prácticas Preprofesionales';
    public _tituloActivarDisponibilidad = 'Activar disponibilidad';
    public _tituloInactivarDisponibilidad='Inactivar disponibilidad ';
    public _tituloListadoRequerimientosPlanificacion='Listado de Servicios para la';
    public _tituloAprobarRequerimiento='Aprobar Servicios';
    public _tituloNoAprobarRequerimiento='No_aprobar Servicios';
    public _tituloBuscarServicioCatering='Buscar Servicios';
    public _tituloDevolverServiosCatering='Devolver Servicio';
    public _copiar= 'COPIAR';
    public _noObjetoGrillaCopiar: string = 'Debe seleccionar un registro para poder copiarlo.';
    public _tituloAprobar_noAprobarRequerimientoCatering='Aprobar / no_aprobar Servicios';
    public _tituloConfirmar_cancelarRequerimientoCatering='Confirmar / cancelar servicios';
    public _tituloDevolverRequerimientoCatering='Devolver un servicio';
    public _tituloEnviarRequerimientoCateringAprobacion='Enviar servicio para aprobación'
    public _tituloAceptarRequerimientoCatering='Aceptar un Servicio';
    public _tituloConfirmarRequerimientoCatering='Confirmar Servicio'
    public _tituloCancelarRequerimientoCatering='Cancelar Servicio';
    public _tituloRechazarRequerimientoCatering='Rechazar Servicio';
    public _tituloVerDetalleServicioCatering='Ver Detalle de un servicio';
    public _tituloLimiteProduccion="Límite de Producción Excedida";
    public _tituloDetalleVistaProduccion='Listado de Servicios Excedidos en producción';
    public _tituloGestionFichasEstandar='Gestión de fichas Estándar';
    public _tituloTipoFichaEstandar="Tipo Ficha Estándar";
    public _tituloNuevaFichaEstandar='Nueva Ficha Estándar';
    public _tituloPreparacion='Preparación';
    public _tituloDetalleFichaEstandar='Detalle Ficha Estándar';
    public _tituloDetalleProducto='Detalle del producto';
    public _tituloAgregarFichaEstandar='Agregar nuevo Tipo Ficha Estándar';
    public _tituloEditarFichaEstandar='Editar tipo ficha Estándar';
    public _tituloEliminarTipoFichaEstandar='Eliminar Tipo Ficha Estándar';
    public _tituloDetalleFichaPreElaborado='Fichas Pre-elaborados';
   
    public _buscarPorCedulaNombresApellidos='Buscar por cédula o nombre y apellido';

    /********************************************MENSAJES****************************************** */
    public _noHayRegistros='No hay registros';
    public _validacionDisponibilidadMesExistente='Existe ya un registro para este mes';
    public _validacionActivarDisponibilidad='El registro ya se encuentra Activo';
    public _validacionInactivoDisponibilidad='El registro ya se encuentra Inactivo';
    public _validacionSeleccionResgistro='Debe seleccionar un registro';
    public _validacionSoloUnRegistro='Debe seleccionar un solo registro ';
    public _validacionFechasIngresadas='Las fechas ingresadas deben ser correspondientes al mismo mes';
    public _validacionEditarEstadoInactivo='No puede editar una disponibilidad que esta en estado inactivo';
    public _validacionActivarExisteMesActivo='No puede activar, tiene ya una fecha activa para este mes';
    public _validacionMaximoObservaciones= 'Tamaño máximo de observaciones 250';
    public _validacionCrearDisponibilidadExcepcionalMes='Las fechas deben ser mayores a las ultima fecha fin ingresada en el mismo mes';
    public _validacionExisteAsociacionPersonaConDependenica ='No existe una asociación Jefe de Dependencia, comuníquese con el administrador de Ciencias de la Hospitalidad'
    public _validacionExisteDisponibilidad='No hay fechas disponibles para crear una planificación';
    public _validarNombreTipoFicha='Debe ingresar el nombre del tipo ficha';
    public _validarNombreFichaEstandar='Debe ingresar el nombre de la Ficha Estándar';
    public _validarCantidadPorcionFichaEstandar='Debe ingresar la cantidad de la porción';
    public _validarCantidadNetaMayorCero='La cantidad neta ingresada debe ser mayor a cero en el producto';
    public _validarPorcionMayorCero='El desperdicio ingresado debe ser mayor a cero en el producto';
    public _validarCantidadPorcionMayorCero='La cantidad de porción calculada debe ser mayor a cero';
    public _validarPesoPeraracionMayorCero='El peso de preparación ingresada debe ser mayor a cero';
    public _validarPesoPorcionMayorCero='El peso de porción ingresada debe ser mayor a cero';

    public _validarCantidadPesoPreparacion='Debe ingresar el peso de preparación';
    public _validarCantidadPesoPorcion='Debe ingresar el peso de porción';
    public _validarPesoPlato ='Debe ingresar el peso del plato';
    public _validarTiempoPreparacion='Debe ingresar el tiempo de preparación';
    public _validarAlmacenamiento='Debe seleccionar el almacenamiento';
    public _validarCategoriaFichaEstandar='Debe seleccionar la categoria ficha';
    public _validarPartida ='Debe seleccionar una partida';
    public _validarDificultad='Debe seleccionar una dificultad';
    public _validarValorMultiplicador='Debe ingresar el valor del multiplicador';
    public _validarProductoEnDetalleFichaEstandar='Debe agregar producto al detelle de la ficha estándar';
    public _validarUnidadMedida='Debe seleccionar una unidad de medida en el producto';
    public _validarCantidadBruta='Debe ingresar valores en cantidad neta y desperdicio para calcular la  cantidad bruta del producto';
    public _validarRendimiento ='Debe agregar el desperdicio del producto';
    public _validarCatidadMultiplicador='Debe calcular el multiplicador del producto';
    public _validarCantidadNeta='Debe agregar la cantidad neta al producto';
    public _validacionMaximoNombreFicha= 'El Tamaño máximo del nombre debe ser de 150';
    public _validacionMaximoDescripcion= 'Tamaño máximo de descripcion 250';
    public _validacionNombreTipoFicha ='El nombre del tipo ficha ya existe';
    public _validarNombreFicha ='El nombre de la ficha estándar ya existe';
    public _validarComplementoFicha = 'Debe seleccionar el complemento de ficha';
    public _validarPesoPreparacionMayorPesoPorcion = 'El peso de porción debe ser menor al peso de preparación';
    public _validarDesperdicioMaximo='El valor máximo del desperdicio es de 100% del producto';

    public _mensajeCuandoInactiva='Cuando Inactive el registro, no será posible crear planificaciones para las dependencias';
    public _mensajeCuandoActiva='Cuando Active el registro, será posible crear planificaciones para las dependencias'
    public _mensajeEliminarDisponibilidadCuandoExistePlanificacion='No puede eliminar el registro, existen servicios registrados';
    public _mensajeDesactivarDisponibilidadCuandoExistePlanificacion='No puede desactivar el registro, ya se registraron planificaciones';
    public _mensajeCreacionDisponibildadExcepcional='Las fechas que ingrese debe ser mayor o igual a la fecha actual';
    public _mensajeCrearDisponibilidadExcepcionaMesActual='Solo puede crear una disponibilidad excepcional para el mes actual';
    public _mensajeEliminarDisponibilidadExcepcionalPlanificacion='No puede eliminar el registro, existe un servicio registrado ';
    public _mensajeDesactivarDisponibilidadExcepcionalPlanificacion='No puede desactivar el registro, exista una planificación creada';
    public _mensajeServiciosCateringAceptados='Los registros ya fueron aceptados por Hospitalidad, No se puede cambiar el estado';
    public _mensajeDevolverRequerimiento='Cuando devuelve un servicio, estos podrán ser editados por el rol de analista';
    public _mensajeNoAprobarRequerimiento='Los registros seleccionados ya se encuentran NO_APROBADA';
    public _mensajeAprobarRequerimientoCatering='Los servicios que pasan a estado aprobada serán conocidos por Ciencias de la Hospitalidad';    
    public _mensajeNoAprobarRequerimientoCatering='Los servicios que tengan estado no_aprobada, no podrán ser editadas y no serán visibles para Ciencias de la Hospitalidad';
    public _mensajeValidarDevolverRequerimientoCatering='Solo puede devolver los servicios que esten en estado "POR APROBAR"';
    public _mensajeEliminarPlanificacion='No puede eliminar la planificación, existen servicios relacionados';
    public _mensajeEditarValorPorcentajeParte1='Solo puede editar el ';
    public _mensajeEditarValorPorcentajeParte2='% de la cantidad inicial ingresada';
    public _mensajeValidacionConfirmarDireccionReferencia='Falta registrar la dirección de referencia del evento';
    public _mensajeValidacionConfirmarHoraServicio='Falta registrar la hora del servicio del evento';
    public _mensajeValidacionConfirmarResponsable='Falta registrar la persona responsable de recibir el servicio';
    public _mensajeValidacionConfirmarTelefono='Falta registrar el teléfono de la persona responsable';
    public _mendajeValidacionEstadoBotonConfirmarCancelar='Solo puede Confirmar o cancelar un servicio en estado ACEPTADA';
    public _mensajeValidacionTiempoConfirmarServicioCatering='No es posible confirmar el servicio, No se encuentra dentro del tiempo permitido'
    public _mensajeConfirmarAceptarRequerimientoCatering='Un servicio aceptado podrá ser confirmado o cancelado por el rol de analista';
    public _mensajeValidacionTiempoCancelarServicioCatering='No es posible cancelar un servicio, No se encuentra dentro del tiempo permitido';
    public _mensajeConfirmarServicioCatering='Un servicio confirmado, No podrá ser cancelado';
    public _memsajeCancelarServicioCatering='El servicio cancelado, será descartado por ciencias de la hospitalidad';
    public _mensajeValidarRazonRechazo='Debe ingresar la razón del rechazo';;
    public _mensajeTamanioRechazo='Tamaño máximo de 150';
    public _mensajeServicioConfirmado='El servicio ya fue confirmado no puede editar';
    public _mensajeServicioCancelado='El servicio ya fue cancelado no puede editar';
    public _mensajeServicioRechazado='El servicio ya fue rechazado no puede editar';
    public _mensajeValidaDisponibilidadEnviarAprobacion='No es posible enviar para Aprobación, No se encuentra dentro del tiempo permitido ';
    public _mensajeLimiteProduccionDiaria='El Límite de producción diaria es ';

    public _indicacionesIngresarFechas = 'Las fechas seleccionadas (Inicio y Fin) deben pertenecer al mismo mes';
    public _indicacionesFechasPorMes='Solo puede existir un registro por mes';
    public _indicacionesObligatorias='(*) Campos obligatorios';
    public _indicacionesEliminar='Cuando se elimina un registro, las dependencias no podrán ingresar servicios';
    public _indicacionesEliminarExcepcional='Cuando elimine el registro, las dependencias no  podrán registrar un servicio excepcional';
    public _indicacionesEditarFechaSiExisteDependenciaAsociada='Ya existen servicios registradas, no puede ingresar fechas menores al día ';
    public _indicacionesCrearPlanificacionExcepcional='No existe una fecha disponible para crear una planificacióne excepcional';
    public _indicacionesCrearPlaniExcepcionalExistePlanMesAnterio='Puede ingresar los requerimientos ingresando en la planificación del mes anterior';
    //====================================================== ETIQUETA LABELS ===============================

    public _diaInicio='Día Inicio';
    public _diaFin= 'Día Fin';
    public _dependencia='Dependencia';
    public _personaAutoriza='Persona que autoriza';
    public _verDetalle='VER DETALLE';
    public _regresar='REGRESAR';
    public _inactivo='Inactivo';
    public _Si='SI';
    public _No='NO';
    public _agregarExcepcional='Agregar Excepcional';
    public _movitivoRechazo='razón de rechazo'
    
    //__________________________________________________________________________________________________//
    //CALENDARIO

    public _calendarioEspanol: any = {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
    };

    //colores estados servicio catering
    public _COLOR_ESTADO_NOAPROBADO:string = 'NO APROBADA';
    public _COLOR_ESTADO_APROBADA:string = 'APROBADA';
    public _COLOR_ESTADO_ACEPTADA:string = 'ACEPTADA';
    public _COLOR_ESTADO_ELABORADA:string = 'ELABORADA';
    public _COLOR_ESTADO_PORAPROVAR:string = 'POR APROBAR';
    public _COLOR_ESTADO_PLANIFICACION_PENDIENTE:string = 'PENDIENTE';
    public _COLOR_ESTADO_PLANIFICACION_REVISADO:string = 'REVISADO';

    public _aniosRango: any = `1900:2030`;

    //DÍAS
    public _lunes = 'Lunes';
    public _martes = 'Martes';
    public _miercoles = 'Miércoles';
    public _jueves = 'Jueves';
    public _viernes = 'Viernes';
    public _sabado = 'Sábado';
    public _domingo = 'Domingo';

    //__________________________________________________________________________________________________//
    //ETIQUETAS

    //__________________________________________________________________________________________________//
    //GRILLA

    public _noObjetosGrilla: string = 'No existen registros.';



    // ===================== CONSTANTES PARA LOS MENSAJES DEL SISTEMA =======================================================//


    //__________________________________________________________________________________________________//
    //CLICK CRUD

    public _clickActualizarError: string = 'Error en click Actualizar.';
    public _clickEliminarError: string = 'Error en click Eliminar.';
    public _clickGuardarError: string = 'Error en click Guardar.';

    //__________________________________________________________________________________________________//
    // CUADROS MENSAJES CABECERAS
    public _cabeceraConsultarEliminacionRegistro: string = 'Confirmación de eliminación';
    public _cabeceraMensajeInformación: string = 'Información';
    public _cabeceraMensajeExito: string = 'Éxito';
    public _cabeceraMensajeAdvertencia: string = 'Advertencia.';
    public _cabeceraMensajeError: string = 'Error.';

    //__________________________________________________________________________________________________//
    // CUADROS MENSAJES CUERPOS

    public _confirmacionEliminacionRegistro: string = '¿Realmente desea eliminar el registro?';
    public _confirmacionEliminacionRegistroCust: string = '¿Realmente desea eliminar el registro @objeto?';    

    //__________________________________________________________________________________________________//
    //ERRORES VARIOS

    public _errorCargarListado = 'Error en cargar listado';
    public _errorCargarListadoCustom: string = 'Error en cargar listado de @objeto';
    public _errorCargarCombo: string = 'Error en cargar combo';
    public _errorCargarComboCustom: string = 'Error en cargar combo de @objeto';
    public _errorCargarComboUnidades: string = 'Error en cargar combo de Unidades';
    public _errorBuscarPadreCampus: string = 'Error en buscar padre de campus';
    public _errorBuscarPadreFacultad: string = 'Error en buscar padre de facultad';


    //__________________________________________________________________________________________________//
    //GRILLA

    public _noObjetoGrilla: string = 'Por favor debe seleccionar un registro';
    public _noObjetoGrillaActivar: string = 'Por favor debe seleccionar un registro para poder activarlo.';
    public _noObjetoGrillaDesActivar: string = 'Por favor debe seleccionar un registro para poder activarlo.';
    public _noObjetoGrillaEditar: string = 'Por favor debe seleccionar un registro para poder editarlo.';
    public _noObjetoGrillaHorario: string = 'Por favor debe seleccionar un registro para poder editar su horario.';
    public _noObjetoGrillaEliminar: string = 'Por favor debe seleccionar un registro para poder eliminarlo.';
    public _noObjetoGrillaSeleccionGeneral = 'Por favor debe seleccionar un registro.';
    public _noObjetosGrillaCust = 'No existen registros de @objeto.';
    public _noObjetoGrillaEditarCust = 'Por favor debe seleccionar un registro @objeto para poder editarlo.';
    public _noObjetoGrillaEliminarCust = 'Por favor debe seleccionar un registro @objeto para poder eliminarlo.';
    public _noObjetoGrillaSeleccionGeneralCust = 'Por favor debe seleccionar un registro de @objeto';

    public _COLOR_DEL_ESTADO_ELABORADA:string = '#0277BD';
    public _COLOR_DEL_ESTADO_PORAPROBAR:string = '#FF9800';
    public _COLOR_DEL_ESTADO_APROBADA:string = '#01b461';
    public _COLOR_DEL_ESTADO_NOAPROBADA:string = '#AD1457';
    public _COLOR_DEL_ESTADO_ACEPTADA:string = '#4527A0';
    public _COLOR_DEL_ESTADO_RECHAZADA:string = '#F44336';
    public _COLOR_DEL_ESTADO_CONFIRMADA:string = '#0B8043';
    public _COLOR_DEL_ESTADO_NOCONFIRMADA:string = '#dd04b9';
    public _COLOR_DEL_ESTADO_CANCELADA:string = '#795548';

    public _textoEstadoElaborada:string='El rol analista crea un servicio.';
    public _textoEstadoPorAprobar:string='El rol analista envía un servicio al jefe de dependencia para aprobar.';
    public _textoEstadoAprobada:string='El rol jefe de dependencia ha aprobado el servicio.';
    public _textoEstadoNoAprobada:string='El rol jefe de dependencia no ha aprobado el servicio.';
    public _textoEstadoAceptada:string='El rol reponsable de CC.HH. ha aceptado el servicio y será atendido.';
    public _textoEstadoRechazada:string='El rol reponsable de CC.HH. ha rechazado el servicio y no será atendido.';
    public _textoEstadoConfirmada:string='El rol analista con el aval del rol Jefe de Dependencia confirmó la orden de pedido.';
    public _textoEstadoCancelada:string='El rol analista con el aval del rol Jefe de Dependencia cancela la orden de pedido.';
    public _textoEstadoNoConfirmada:string='Cuando una orden de pedido no ha sido confirmada ni cancelada por el rol analista.';
    

    //__________________________________________________________________________________________________//
    //MENSAJES VALIDACIONES CAMPOS Y OBJETOS
    // En la parte inicial de esta sección se han agregado los nombres de campos comunes.
    // Antes de agregar un nombre en cada subsección por componente verificar si el nombre de atributo no está repetido
    // en otra subsección para ponerlo en la parte superior.

    public _asignaturaRequerida = 'Asignatura Requerida';
    public _asignaturasRequeridas = 'Asignaturas Requeridas';
    public _codigoValidacion = 'El código es requerido';
    public _equivalenciaRequerida = 'Equivalencia Requerida';
    public _debeSeleccionarCombo = 'Debe seleccionar @objeto';
    public _descripcionValidacion = 'La descripcion es requerida';
    public _fechasInicioFinValidadcion = 'La fecha de fin debe ser mayor a la fecha de inicio';
    public _fechaInicioRequerida = 'La fecha de inicio es requerida';
    public _fechaFinRequerida = 'La fecha de fin es requerida';
    public _institucionValidacion = 'La institución es requerida';    
    public _nombreValidacion = 'El nombre es requerido';
    public _correoValidación = 'El correo electrónico es requerido';
    public _unidadRequerida = 'La unidad es requerida';
    public _tipoUnidadRequerida = 'El tipo de unidad es requerida';
    public _periodoRequerido = 'El periodo es requerido';
    public _saltoLineaDetalle = '<br>-';
    public _saltoLinea = '<br>';
    public _tituloMensajeValidacionGrupal = 'Por favor revisar: <br>';
    public _valorMayorCero = 'El valor debe ser mayor a cero';
    public _notaAprobacionValidacion = 'La Nota de Aprobacion es requerida';
    public _numeroAportesValidacion = 'El numero de aportes es requerido';
    public _numeroDecimalesValidacion = 'El numero de decimales es requerido';
    public _abreviaturaValidacion = 'La abreviatura es requerida';
    public _formulaValidacion = 'La fórmula es requerida';
    public _aportesValidacion = 'El registro debe tener al menos un aporte';
    public _condicionValidacion = 'La condicion es requerida';
    public _valorMayorIgualCero = 'El registro debe ser mayor o igual a cero';
    public _formulaConstruccionValidacion = 'La fórmula no se encuentra correctamente construida';
    public _formatoCorreoElectronico = 'Formato Correo Electronico';
    public _padreCampus = 'Sede / Extensión a la que pertenece EL CAMPUS';
    public _padreFacultad = 'Campus a la que pertenece la facultad';
    public _tipoVariable = 'Tipo de Variable requerida';
    public _unidadBusquedaTresCaracteres = 'Seleccione la unidad e ingrese la palabra que desea buscar que tenga como mínimo tres caracteres';
    public _criterioBusquedaValidacion = 'Ingrese un criterio de busqueda valido';
    public _configuracionCalificacionRequerida = 'La configuración de calificación es requerida';
    public _detalleCalificacionRequerida = 'El detalle de calificación es requerido';
    public _tipoValorRequerido = 'Tipo de Valor requerido';
    public _categoriaParametroRequerida = 'Categoria Parámetro requerida';
    public _parametroMatriculaRequerida = 'El tipo de matricula es requerida.';
    public _revisarCampos = 'Revisar los siguientes campos: ';
    public _servicioValidacion = 'El servicio es requerido';
    public _temaRequerido = 'El tema es requerido';
    public _tipoParametroRequerido = 'El tipo de parámetro es requerido';
    public _numeroCuposRequerido = 'El número de cupos es requerido';
    public _parametroRequerido = 'El parámetro es requerido';
    public _parametroComponenteIncorrecto = 'El parámetro de acceso al componente es incorrecto, ni tiene permiso para usar esta funcionalidad';
    public _modalidadEstudioRequerida = 'La modalidad de estudio es requerida';
    public _nivelFormacionRequerido = 'El nivel de formación es requerido';
    public _numeroMaximoAsignaturasRequerido = 'El número máximo de asignatura es requerido';
    public _numeroHorasRequeridoMayorCero = 'El número de horas es requerido y debe ser mayor a cero';
    public _numeroPeriodosOrdinariosRequeridoMayorCero = 'El número de periodos ordinarios es requerido y debe ser mayor a cero';
    public _porcentajeMinimoHorasAsistidoDocenteRequeridoMayorCero = 'El porcentaje mínimo de horas asistido por el docente es requerido y debe ser mayor a cero';
    public _porcentajeMaximoHorasAsistidoDocenteRequeridoMayorCero = 'El porcentaje máximo de horas asistido por el docente es requerido y debe ser mayor a cero';
    public _numeroMinimoHorasRequeridoMayorCero = 'El número mínimo de horas es requerido y debe ser mayor a cero';
    public _numeroMaximoHorasRequeridoMayorCero = 'El número máximo de horas es requerido y debe ser mayor a cero';
    public _numeroSemanasRequeridoMayorCero = 'El número de semanas es requerido y debe ser mayor a cero';
    public _mensajeDocenteExiste = 'Ya existe un docente registrado con la identificación proporcionada. Por favor regrese a la búsqueda o ingrese otra identificación.'
    public _mensajeCamposRequeridos = 'Por favor ingrese todos los campos requeridos.'
    public _tipoPeriodoRequerido = 'El tipo de periodo es requerido';
    public _clasePeriodoRequerida = 'La clase de periodo es requerida';
    public _fechaInicioRangoPeriodo = 'La fecha de inicio debe estar entre los límites del periodo.';
    public _fechaFinRangoPeriodo = 'La fecha de fin debe estar entre los límites del periodo.';
    public _funcionalidadRequerida = 'La funcionalidad es requerida.';
    public _tipoServicioRequerido = 'El tipo de servicio es requerido';
    public _numeroEspaciosFisicosRequerido = 'El número de espacios físicos es requerido';
    public _numeroPisosRequerido = 'El número de pisos es requerido';
    public _numeroPisoRequerido = 'El número de piso es requerido';
    public _campusRequerido = 'El campus es requerido';
    public _capacidadRequerida = 'La capacidad es requerida';
    public _bloqueRequerido = 'El bloque es requerido';
    public _tipoEspacioFisicoRequerido = 'El tipo de espacio fisico es requerido';
    public _ofertaRequerida = 'La oferta es requerida';
    public _ofertaFinalizadaNoEliminar = 'La oferta está finalizada y no se puede eliminar';
    public _archivoRespaldoRequerido = 'El Archivo de respaldo es requerido';
    public _archivoRespaldoOfertaGratuitaRequerido = 'El Archivo de respaldo es requerido cuando la oferta es gratuita';

    public _debe = 'Debe';
    public _haber = 'Haber';
    
    //--------------------------------------------------------------------------------------------------//
    //mensajes servicio catering
    public _servicioCateringSingular = "Servicio de prácticas preprofesionales";

    //--------------------------------------------------------------------------------------------------//
    //mensajes configuracion de parámetros
    public _configuracionParametros = "Configuración de parámetros";
    public _tiempoCancelarServicio = "Tiempo límite para cancelar un servicio";
    public _tiempoConfirmarServicio = "Tiempo límite para confirmar un servicio";
    public _limiteDiarioProduccion = "Límite diario de producción";
    public _porcentajeVariacionServicio = "Porcentaje de variación +- en un servicio";

    //--------------------------------------------------------------------------------------------------//
    //mensajes asociacion unidad catering

    public _personaRequerida = "La persona es requerida";
    public _dependenciaRequerida = "La dependencia es requerida";
    public _idPersona = "Id Persona";
    public _nombrePersona = "Nombre Persona";
    public _nombreDependencia = "Nombre Dependencia";
    public _asociarJedeDepedencia = "Asociar Jefes de Dependencia";
    public _nuevoJefeDependencia = "Nuevo Jefe de Dependencia";    
    public _ingreseIdentificacion = "Ingrese la identificación";
    public _eliminarJefeDependencia = "Eliminar Jefe de Dependencia";
    public _desactivarJefeDependencia = "Desactivar Jefe de Dependencia";
    public _noObjetoGrillaActivo: string = 'Por favor debe seleccionar un registro activo para poder desactivarlo.';

    //--------------------------------------------------------------------------------------------------//
    //mensajes servicio catering
    public _servicioCatering = "Servicios de Prácticas Preprofesionales";
    public _nuevoServicioCatering = "Nuevo servicio";
    public _editarServicioCatering = "Editar servicio";
    public _suEleccionProductosCatering = "Su elección";
    public _datosEventoServicioCatering = "Datos del Evento";
    public _categoria = "Categoría";
    public _producto = "Producto";
    public _precio = "Valor unitario";
    public _cantidad = "Cantidad";
    public _seleccionarProducto = "Seleccionar producto";
    public _deseleccionarProducto = "Deseleccionar producto";
    public _verProducto = "Ver producto";
    public _horaServicioEnEvento = "Hora servicio en el evento";
    public _caracteresRestantes = "Caracteres restantes";
    public _referenciaDireccion = "Referencia Dirección";
    public _datosPersonaContactoServicioCatering = "Persona de contacto para el servicio";
    public _valorTotal = "Valor total";
    public _valorTotalEleccion = "Valor total de elección";    
    public _fechaEvento = "Fecha evento";
    public _evento = "Evento";
    public _eliminarServicioCatering = "Eliminar servicio";    
    public _copiarServicioCatering = "Copiar servicio";    
    public _regresarPlanificaciones = 'REGRESAR A LAS PLANIFICACIONES'    
    public _noObjetoGrillaContinuar: string = 'Por favor debe seleccionar un registro para poder continuar.';
    public _noObjetoGrillaEnviarParaAprobar: string = 'Por favor debe seleccionar un registro para poder enviar para aprobación.';
    public _detalleDireccion = "Indicar el lugar del evento, en la pestaña DETALLES PARA ENTREGA se ingresará la información precisa";
    public _valorUnitario = "Valor Unitario";
    public _valorTotalAcumuladoPlanificacion = "Valor Total Acumulado";
    public _direccionEspecifica = "Dirección específica de entrega";
    public _horaServicioEvento = "Hora de servicio en el evento";
    public _personaDeContactoParaServicio= "Persona de contacto para entrega";
    public _celular = "Celular";
    public _requerimientos = "Requerimientos";
    public _nosePermitenCaracteresEspeciales = 'No se permiten caracteres especiales en la búsqueda';
    

    //******************************VALIDACIONES**************************  */

    public _validarCampoFechaInicioDisponibilidad='El campo fecha inicio es requerido';
    public _validarCampoFechaFinDisponibilidad='El campo fecha fin es requerido';_
    public _validarRangoFechaDisponibilidad='La fecha Inicio debe ser menor a la fecha Fin';
    public _validarElMismoMesFechaDisponibilidad='Se requiere que las fechas correpondan al mismo mes';
    public _validacionObservacionesRequeridas='Las observaciones son requeridas';
    public _validarPersonaAutoriza= 'Persona autoriza es obligatorio';
    

    //OBJETO CRUD MENSAJES

    public _objetoActualizarError = 'Error al actualizar el registro.';
    public _objetoActualizarErrorCust = 'Error al actualizar @objeto.';
    public _objetoActualizarExito = 'Se actualizó con éxito el registro.';
    public _objetoActualizarExitoCust = 'Se actualizó con éxito @objeto.';
    public _objetoEliminarError = 'Error al eliminar el registro.';
    public _objetoEliminarErrorCust = 'Error al eliminar @objeto.';
    public _objetoEliminarExito = 'Se eliminó con éxito el registro.';
    public _objetoEliminarExitoCust = 'Se eliminó con éxito @objeto.';
    public _objetoGuardarError = 'Error al almacenar el registro.';
    public _objetoGuardarErrorCust = 'Error al almacenar @objeto.';
    public _objetoGuardarExito = 'Se almacenó con éxito el registro.';
    public _objetoGuardarExitoCust = 'Se almacenó con éxito @objeto.';
    public _objetoFinalizaExito = 'El registro se finalizó con exito';
    public _objetoFinalizaError = 'Error al finalizar el registro';

    public _objetoIngresarDatos = 'Ingrese los siguientes datos';
    public _objetoIngresarDatosPara = 'Ingrese los siguientes datos para: ';

    public _registrosAlmacenarExito = 'Registros almacenados con éxito.'
    public _registrosAlmacenarError = 'Error al almacenar los registros.'


    //__________________________________________________________________________________________________//
    // NOMBRES OBJETOS
    // Para ser usados en mensajes custom


    public _objBloque = 'Bloque';
    public _objCampus = 'Campus';
    public _objCampoFormacion = 'Campo de Formación';
    public _objCarrera = 'Carrera';
    public _objCategoriaParametro = 'Categoría Parámetro';
    public _objCondicionPrematricula = 'Condición Prematrícula';
    public _objConfiguraciónPrematricula = 'Configuración Prematrícula';
    public _objEspacioFisico = 'Espacio Físico';
    public _objEstructuraCurricular = 'Estructura Curricular';
    public _objFacultad = 'Facultad';
    public _objMapeoVariable = 'Mapeo Variable';
    public _objModalidadEstudio = 'Modalidad de Estudio';
    public _objParametro = 'Parametro';
    public _objParametroPrematricula = 'Parametro Prematrícula';
    public _objParametroValor = 'Parametro Valor';
    public _objPeriodoNombre = 'Periodo';
    public _objRelacionComponenteAprendizaje = 'Relación Componente Aprendizaje';
    public _objNivelFormacion = 'Nivel de Formacion';
    public _objTemaNombre = 'Tema';
    public _objTipoVariable = 'Tipo Variable';
    public _objTipoEspacioFisico = 'Tipo Espacio Físico';
    public _objUnidadOrganizacion = 'Unidad de Organizacion';
    public _objVariable = 'Variable';



    // __________________________________________________________________________________________________//
    // SERVICIOS MENSAJES

    public _servicioNoDisponible = 'Servicio no disponible por el momento.';
    public _servicioNoDisponibleCust = 'Servicio @servicio disponible por el momento.';

    // Servicios crud errores

    public _servicioErrorActualizar = 'Error al actualizar.';
    public _servicioErrorBuscar = 'Error al buscar.';
    public _servicioErrorGuardar = 'Error al guardar.';
    public _servicioErrorEliminar = 'Error al eliminar.';
    public _servicioErrorListar = 'Error al listar.';
    public _servicioErrorActualizarCust = 'Error al actualizar @objeto.';
    public _servicioErrorBuscarCust = 'Error al buscar @objeto.';
    public _servicioErrorGuardarCust = 'Error al guardar @objeto.';
    public _servicioErrorListarCust = 'Error al listar @objeto.';


    // objeto service 1

    // __________________________________________________________________________________________________//
    // SERVICIOS NOMBRES

    public _servicioPersona = 'Persona';
    public _servicioOferta = 'Oferta';
    public _configuracionInformacion = 'Configuración de Información';
    public _servicioConfiguracionFinanciera = 'Configuración Financiera';
    public _servicioUnidad = 'Unidad';


    // A
    public _accesoDiscapacitados = 'Acceso Discapacitados';    
    public _accesibilidadDiscapacitados = 'Accesibilidad Discapacitados';    
    public _asignatura = 'Asignatura';
    public _asignaturas = 'Asignaturas';
    public _alumno = 'Estudiante';
    public _asignaturasRegistradas = 'Asignaturas Registradas';
    public _asignaturasDisponibles = 'Asignaturas Disponibles';
    public _asignaturasEquivalentes = 'Asignaturas Equivalentes';

    public _abreviatura = 'Abreviatura';
    public _horasDocencia = 'Horas de Docencia';
    public _horasDocenciaSemanales = 'Horas de Docencia Semanales';

    public _agregar = 'AGREGAR';
    public _agregarEditar = 'Agregar/Editar';
    public _aptoRecibirClases = 'Apto para recibir clases';


    public _aceptar = 'ACEPTAR';
    public _aportes = 'Aportes'
    public _aporteDuplicado = 'No se puede tener un aporte con el mismo nombre o abreviatura';
    public _apellidoPrimero = 'Primer Apellido';
    public _apellidoSegundo = 'Segundo Apellido';
    public _asignaturaYaOfertada = 'La asignatura ya se encuentra ofertada.';
    public _asignaturaOfertada = 'Asignatura ofertada con éxito.';
    public _asignaturaNoOfertada = 'La asignatura no se encuentra ofertada.';
    public _apellidos = 'Apellidos';
    public _aprobarEstado = 'Aprobar Estado';
    public _agregarDescuentoRecargo = 'Agregar Descuento/Recargo';
    public _anular = 'Anular';
    public _aprobar = 'Aprobar';

    public _asignarDocentes = 'Asignar Docentes';
    public _reservarCupos = 'Reservar Cupos';
    public _anio = 'Año';
    public _activo = 'Activo';
    public _advertencia = 'Advertencia';

    public _archivoCargadoExistosamente = 'Archivo cargado exitosamente ';
    public _archivoErrorCarga = 'Error en la carga del archivo ';
    public _actualizar = 'Actualizar';
    

    // B
    public _buscar = 'Buscar';
    public _busquedaOtrosServicios = 'Buscar Otros Servicios';
    public _busquedaClienteProveedor = 'Busqueda de Cliente Proveedor';
    public _buscarClienteProveedor = 'Buscar Cliente Proveedor';
    public _buscarClientesProveedores = 'Buscar Clientes Proveedores';
    public _busquedaProductos = 'Busqueda de Productos';
    public _busquedaConfiguracionFinanciera = 'Búsqueda de Configuración Financiera';
    public _busquedaPlantillasConfiguracion = 'Búsqueda de Plantillas de Configuracion';
    public _busquedaPlantillasConfiguracionFinanciera = 'Búsqueda de Plantillas de Configuracion Financiera';
    public _busquedaFormaCobro = 'Búsqueda de Formas de Cobro';

    // C
    public _cadena1 = 'Cadena 1';
    public _cadena2 = 'Cadena 2';
    public _calificacionesCursos = 'Calificaciones de Cursos';
    public _cambiosGrupo = 'Cambios de Grupo';
    public _camposFormacion = 'Campos de Formación';
    public _cancelar = 'CANCELAR';
    public _capacidad = 'Capacidad';
    public _carrera = 'Carrera'
    public _categoriasParametros = 'Categorías de Parámetros'
    public _codigo = 'Código';
    public _codigoAsignatura = 'Cód. Asignatura';

    public _componenteAprendizaje = 'Componente de Aprendizaje';

    public _componente = 'Componente';
    public _componentes = 'Componentes';
    public _cerrar = 'Cerrar';
    public _configuracionCalificacion = 'Configuración de Calificación'

    public _clase = 'Clase';
    public _condicion = 'Condición';
    public _comparador = 'Comparador';
    public _configuracionParametrosPrematricula = 'Configuración de Parámetros para Prematrícula';
    public _clasificacion = 'Clasificación';
    public _contenidos = 'Contenidos';

    public _consulta = 'Consulta';
    public _consultar = 'Consultar';
    public _confInformacion = 'Conf. Información';
    public _confFinanciera = 'Conf. Financiera';
    public _configuracionesFinancieras = 'Configuraciones Financieras';

    public _correoElectronico = 'Correo Electrónico';
    public _convenio = 'Convenio';
    public _convenios = 'Convenios';
    public _codigoConvenio = 'Codigo Convenio';
    public _conceptosCobro = 'Conceptos de Cobro';
    public _continuar = 'Continuar';
    public _creditos= 'Créditos'

    public _concepto = 'Concepto';
    public _conceptoCobro = 'Concepto de Cobro';
    public _criterio = 'Criterio';
    public _categoriaProducto = 'Categoría Producto';
    public _correspondenciaProducto = 'Correspondencia con Producto';
    public _codigoReserva = 'Codigo de Reserva';
    public _codigoReservaNoValido = 'Codigo de Reserva no valido';
    public _correo= 'Correo';

    public _cursoModulo = 'Módulo';
    public _cursosModulos = 'Módulos';
    public _cursosConModulos = 'Estructuras de Cursos';
    public _configuracionFinanciera = 'Configuración Financiera';
    public _correspondenciaOpenERP = 'Correspondencia Open ERP';
    public _cuposDisponibles = 'Cupos Disponibles';

    public _controlManual = 'Control Manual';
    public _cuotas = 'Cuotas';
    public _cambiarFormaCobro = 'Cambiar Forma Cobro';
    public _cambiar = 'Cambiar';
    public _cursoPosgrado = 'Curso de Posgrado';
    public _cohortePosgrado = 'Cohorte de Posgrado';

    // D
    public _descripcion = 'Descripción';
    public _distribucionGrupo = 'Distribución de cupos en los grupos';
    public _detalleCalificacion = 'Detalle de Calificación';
    public _docente = 'Docente';
    public _docentes = 'Docentes';
    public _detalleCostos = 'Detalle de Costos';
    public _detalle = 'Detalle';
    public _dirigidoa = 'Dirigido a';
    public _datosOferta = 'Datos de la Oferta';
    public _datosServicio = 'Datos del Servicio';
    public _descuento = 'Descuento';
    public _detallesConfiguracionFinanciera = 'Detalles de la Configuración Financiera';
    public _detalleConfiguracionFinanciera = 'Detalle de Configuración Financiera';
    public _descuentosRecargos = 'Descuentos/Recargos';
    public _descuentoRecargo = 'Descuento/Recargo';
    public _direccion = 'Dirección';
    public _datosAsignatura = 'Datos de la Asignatura';    
    public _datosPersonales = 'Datos Personales'

    

    // E
    public _editar = 'EDITAR';
    public _eliminar = 'ELIMINAR';
    public _elegir= 'Elegir';
    public _equivalencia = 'Equivalencia';
    public _equivalencias = 'Equivalencias';
    public _estado = 'Estado';
    public _estadosAprobacion = 'Estados de Aprobación';
    public _estadoAprobacion = 'Estado de Aprobación';
    public _extension = 'Extensión';
    public _estructuraCurricular = 'Estructura Curricular';
    public _esVoluntario = '¿Voluntario?';
    public _estudiantes = 'Estudiantes';
    public _esFinal = 'Es final';
    public _esInicial= 'Es inicial';
    public _esPorDefecto = 'Es por defecto';
    public _porEvaluacion = 'Calculado por evaluación'
    public _espacioFisico = 'Espacio físico';
    public _editarPlantillaConfiguracion = 'Editar Plantilla de Configuración';
    public _estadoEmpleado = 'Estado del empleado';
    public _estructurasCurriculares = 'Estructuras Curriculares';
    public _examen = 'Examen';
    public _estudiante = 'Estudiante';
    public _eliminacionRegistros = 'Eliminación de Registros de Estudiantes';

    // F
    public _fechaInicio = 'Fecha Inicio';
    public _fechaInicioVigencia = 'Fecha Inicio de Vigencia';
    public _fechaFinVigencia = 'Fecha Fin de Vigencia';
    public _fechaNacimiento = 'Fecha Nacimiento'
    public _fechaFin = 'Fecha Fin';
    public _fecha1 = 'Fecha 1';
    public _fecha2 = 'Fecha 2';
    public _finalizar = 'Finalizar';
    public _formula = 'Fórmula';
    public _formulas = 'Fórmulas';
    public _formasEvaluacion = 'Formas de Evaluación';
    public _formaEvaluacion = 'Forma de Evaluación';
    public _formasCalificacion = 'Formas de Calificación';
    public _formaCalificacion = 'Forma de Calificación';
    public _flujo = 'Registro de Estudiantes';
    public _flujoProcesos = 'Flujo de Procesos';
    public _formaPago = 'Forma Pago';
    public _formasPago = 'Forma(s) Pago';
    public _formatoHora = 'hh:mm';
    public _facturar = 'Facturar';
    public _funcionalidad = 'Funcionalidad';
    public _fecha = 'Fecha';
    public _formasCobro = 'Formas de Cobro';
    public _formaCobro = 'Forma de Cobro';
    public _fechaEmision = 'Fecha de Emisión';
    public _fechaCaducidad = 'Fecha de Caducidad';
    public _fechaPago = 'Fecha de Pago';
    public _fechaMaximaPago = 'Fecha Máxima de Pago';
    public _fechaInicioPeriodo = 'Fecha de inicio del periodo';
    public _fechaFinPeriodo = 'Fecha de fin del periodo';
    public _fechaInicioOferta = 'Fecha de inicio de la oferta';
    public _fechaFinOferta = 'Fecha de fin de la oferta';
    public _fechaInicioClases = 'Fecha de Inicio de Clases';
    public _fechaFinClases = 'Fecha de Fin de Clases';

    //G
    public _guardar = 'GUARDAR';
    public _gruposHorarios = 'Grupos y Horarios';
        public _grupo = 'Grupo';
    public _grupos = 'Grupos';
    public _generar = 'Generar';

    // H
    public _horario = 'Horario';
    public _horarioClase = 'Horario de Clase';
    public _horarios = 'Horarios';
    public _horarioClaseGrupo = 'Horario de clase por grupo';
    public _horarioGrupo = 'Horario de Grupo';
    public _habilitadoInternet = 'Habilitado Internet';
    public _horarioSeleccionado = 'Horario Seleccionado';
    public _horariosDisponibles = 'Horarios Disponibles';
    public _horaInicio = 'Hora Inicio';
    public _horaFin = 'Hora Fin';
    public _habilitadoEstudiante = 'Habilitado Estudiante';

    // I

    public _id = 'ID';
    public _identificacion = 'Identificación';
    public _imprimible = 'Imprimible';
    public _imprimir = 'Imprimir'
    public _imprimirComprobante = 'Imprimir Comprobante';
    public _iva = 'IVA ($)';
    public _informacionOferta = 'Informacion de la Oferta';
    public _ingresarNuevaFicha = 'Ingresar Nueva Ficha';
    public _ingresarNuevoDocente = 'Ingresar Nuevo Docente';
    public _interes = 'Interes';
    public _itinerario = 'Itinerario';

    // L

    public _largo = 'Largo';
    public _listado = 'Listado';
    public _listadoEstudiantes = 'Listado de Estudiantes';
    public _lista = 'Lista';
    public _listadoClienteProveedores = 'Listado de Clientes Proveedores';
    public _listadoEstudianteProceso = 'Listado de Estudiantes por Proceso';
    public _listadoCursosPosgradoHabilitados = 'Listado de Cursos de Posgrado No Ofertados';

    // M

    public _mantenimiento = 'Mantenimiento';

    public _mensajeNoExisteRegistros = 'No existen registros.';
    public _mensajeSeleccioneRegistro = 'Por favor seleccione un registro.';
    public _mensajeSeleccioneSoloUnRegistro = 'Debe seleccionar solamente un registro.';

    public _mensajeNoExisteInformacionEstudiante = 'No se encontró información del estudiante.';

    public _mensajeNoFinalizarMatricular = 'Error al finalizar la matrícula.';

    public _mensajeMatriculaFinalizada = 'La matrícula ya se encuentra finalizada.';

    public _mensajePeriodoOfertaIncorrectos = 'No se encontró un periodo y oferta para los identificadores proporcionados.';

    public _mensajeConfirmacionQuitarDetalle = 'ESTA SEGURO DE QUITAR EL DETALLE SELECCIONADO?';
    public _mensajeConfirmacionOfertaLibreEleccion = '¿Está seguro de abrir la oferta para la asignatura @asignatura? Al aceptar se habilitará a todas las unidades de la universidad para crear grupos para esta oferta.';
    public _mensajeConfirmacionOfertaIngles = '¿Está seguro de abrir la oferta para la asignatura @asignatura?';
    public _mensajeConfirmacionOfertaEducacionFisica = '¿Está seguro de abrir la oferta para la asignatura @asignatura?';
    public _mismoParametroValorFechasTipoUnidadPeriodo = 'Ya existe un parámetro: @parametro, registrado para la unidad: @unidad y el periodo: @periodo, con fecha de inicio: @fecha1 y fecha de fin: @fecha2.';
    public _mensajeConfirmacionEliminarHorario = 'Usted esta a punto de eliminar un horario. ¿Desea continuar?';
    public _mensajeAyudaHoraInicio = 'Ingrese la hora de inicio en el formato hh:mm (Horas : Minutos). Ejemplo: ocho de la mañana 08:00';
    public _mensajeAyudaHoraFin = 'Ingrese la hora de fin en el formato hh:mm (Horas : Minutos). Ejemplo: tres de la tarde 15:00'
    public _mensajeSeleccioneConceptoCobro = 'Seleccione un Concepto de Cobro para el Detalle de Configuración Financiera';
    public _mensajeSeleccioneFormula = 'Seleccione una Fórmula para el Detalle de Configuración Financiera';
    public _mensajeDescuentosRecargos = 'Seleccione un Descuento o Recargo para el Detalle de Configuración Financiera';
    public _mensajeEliminadoExitosamente = 'Registro eliminado satisfactoriamente';
    
    public _mensajeNoExisteCategoriasProducto = 'No existen Categorias de Productos';
    public _mensajeNoExisteProductosCategoria = 'No existen Productos para la categoria seleccionada';
    public _mensajeCodigoReserva = 'Si usted dispone de un codigo de reserva ingreselo en el cuadro de texto y haga clic en Aceptar. ' 
    + 'Caso contrario haga clic en Continuar para matricular al estudiante sin un codigo de reserva';
    public _mensajeIngreseCodigoReserva = 'Ingrese un codigo de reserva';
    public _mensajeOfertaNoPublicada = 'El proceso de la oferta no se encuentra publicado. Diríjase al menú de Publicación de Ofertas.';
    public _modalidadEmpleo = 'Modalidad de Empleo';

    public _mensajeSeleccionarAlMenosUnDia = 'Debe seleccionar al menos un día para crear el horario';
    public _mensajeValidacionHoraInicioMenorHoraFin = 'La hora inicio no puede ser menor o igual a la hora fin';
    public _mensajeHoraInicioRequerida = 'La hora de inicio del horario es requerida';
    public _mensajeHoraFinRequerida = 'La hora fin del horario es requerida';
    public _mensajeConfirmacionEliminarPlantillaConfiguracionFinanciera = '¿Esta seguro que desea eliminar la Plantilla de Configuración Financiera?';
    public _mensajeFinalizarPlantillaConfiguracionFinanciera = 'Usted esta a punto de finalizar la Plantilla de Configuración Financiera. Una vez que la plantilla este finalizada no podrá realizar ninguna modificación. ¿Desea continuar?';
    public _mensajeConfirmacionEliminarPlantillaConfiguracion = '¿Esta seguro que desea eliminar la Plantilla de Configuración?';
    public _mensajeFinalizarPlantillaConfiguracion = 'Usted esta a punto de finalizar la Plantilla de Configuración. Una vez que la plantilla este finalizada no podrá realizar ninguna modificación. ¿Desea continuar?';    
    public _mensajeConfirmacionCambiarConfiguracionFinanciera = 'Usted esta a punto de cambiar la configuración financiera seleccionada. Al aceptar se reiniciarán los valores ya ingresados. ¿Desea continuar?';
    public _mensajeConfirmacionValoresCeroPlantillaFinanciera = 'Existen detalles del tipo valor fijo con valor menor o igual a cero, ¿Desea continuar?';
    public _mensajeValidacionFechaExamenUbicacion = 'Debe seleccionar la fecha cuando se rendira el examen de ubicacion';
    public _mensajeDisponibilidadFechaActual="La fechas deben ser mayor o igual a la fecha actual";
    public _mes='MES';

    public _mensajeConfirmacionGratuidadOferta = 'Usted está a punto de cambiar la gratuidad de la oferta. Al aceptar se eliminarán las plantillas de configuración financiera seleccionadas en las ofertas procesos. ¿Desea continuar?';
    public _mensajeConfirmacionGratuidadOfertaEdicion = 'Usted está a punto de cambiar la gratuidad de la oferta. Al aceptar se eliminarán las configuraciones financiera seleccionadas en las ofertas procesos. ¿Desea continuar?';
    public _movimientos = 'Movimientos';

    public _mensajeValidacionFechaMaximaPagoIngresadaOfertaProceso = 'Se debe especificar la fecha máxima de pago para cada oferta proceso; revisar OfertaProceso ';
    public _mensajeValidacionFechaMaximaPagoMenorFechaActual = 'La fecha máxima de pago debe ser mayor o igual a la fecha actual; revisar OfertaProceso ';
    public _mensajeValidacionFechaMaximaPagoMenorFechaFinProceso = 'La fecha máxima de pago debe ser mayor o igual a la fecha fin del proceso; revisar OfertaProceso ';

    public _modulo = 'Modulo';

    public _matricula = 'Matrícula';

    public _menu = 'Menú';

    // N
    public _nombre = 'Nombre';
    public _no = 'No';
    public _numeroCupos = 'Número de Cupos';
    public _nivel = 'Nivel';
    public _niveles = 'Niveles';
    public _noExisteGrupo = 'No se encontró un grupo para el identificador proporcionado.';
    public _noExisteAsignatura = 'No se encontró una asignatura para el identificador proporcionado.';
    public _noExisteEstructura = 'No se encontró una estructura curricular para el identificador proporcionado.';
    public _noExistenRegistrosParametros = 'No existen registros para los parámetros proporcionados.';
    public _noExistenConfiguracionesCalificacion = 'No existen configuraciones de calificación registradas.';
    public _noExistenDetallesCalificacion = 'No existen detalles de calificación registrados.';
    public _noExistenPadresCampus = 'No existen padres para campus registrados.';
    public _noExistenParametros = 'No existen parámetros registrados.';
    public _noExistenPeriodos = 'No existen periodos registrados.';
    public _noExistenPadresFacultad = 'No existen padres para facultad registrados.';
    public _noExistenTiposServicio = 'No existen tipos de servicio registrados.';
    public _noExistenTiposUnidad = 'No existen tipos de unidad registrados.';
    public _noExisteTipoAsignatura = 'No se encontró el tipo de asignatura para el identificador proporcionado.';
    public _noExistenResultadosParametroBusqueda = 'No existen resultados para el parametro de búsqueda ingresado.';
    public _noMismoObjetoPadre = 'No puede seleccionar el mismo objeto como padre.';
    public _notaAprobacion = 'Nota de Aprobación';
    public _numeroDecimales = 'Número de Decimales';
    public _numeroAportes = 'Número de Registros';
    public _numeroMatricula = 'No. Matrícula';
    public _notaMaxima = 'Nota Máxima';
    public _nombreGrupo = 'Nombre del Grupo';
    public _numeroEstudiantes = 'No. de Estudiantes';
    public _noExisteRegistroPersona = 'No se encontró un resgistro vinculado al estudiante.';
    public _nombrePrimero = 'Primer Nombre';
    public _nombreSegundo = 'Segundo Nombre';
    public _noExistePeriodoVigente = 'No existe un periodo vigente';
    public _noExistePeriodoOferta = 'No existe un periodo habilitado para oferta';
    public _noExistePeriodo = 'No existe un periodo correspondiente al identificador proporcionado.';
    public _noExisteOferta = 'No existe una oferta correspondiente al identificador proporcionado.';
    public _noExistenOfertas = 'No existe existen ofertas';
    public _noExisteOfertaProceso = 'No existe una oferta proceso correspondiente al identificador proporcionado.';
    public _numeroCuposSugerido = 'Número de Estudiantes que podrian tomar la asignatura';
    public _numeroCuposObligatorio = 'Número de Estudiantes a los que se debe garantizar un cupo';
    public _noExisteServicio = 'No existe un servicio correspondiente al identificacion proporcionado';
    public _numeroGrupo = 'No. del Grupo';
    public _noExisteEstudiantesCalificaciones = 'El grupo no tiene estudiantes para registrar calificaciones.'
    public _noExisteEstudiantes = 'El grupo no tiene estudiantes.'
    public _noExisteInformaciónMatrícula = 'No existe información de la matrícula seleccionada.';
    public _noExisteIdRegistroPersona = 'No se proporcionó un identificador de registro persona válido.';
    public _numero = 'No.';
    public _numeroCompleto = 'Número';
    public _nombres = 'Nombres';
    public _nivelFormacion = 'Nivel de Formación';
    public _nivelesFormacion = 'Niveles de Formación';
    public _noClasePeriodoSeleccionada = 'No ha seleccionado una clase de periodo';
    public _nuevaPlantillaConfiguracion = 'Nueva Plantilla de Configuración';
    public _numeroEspaciosFisicos = 'No. Espacios Físicos';
    public _numeroPisos = 'No. Pisos';
    public _numeroPiso = 'No. Piso';

    
    public _noTienePermisoComponente = 'No tiene permiso para acceder a este componente';
    public _numDiasHabilesPapeletasImpresion = 'Número de días hábiles para cancelar papeleta de pago a partir de su emisión';
    public _numDiasHabilesPapeletasReimpresion = 'Número de días hábiles para cancelar papeleta de pago a partir de su re-emisión';
    public _noExistePlantillaConfiguracionFinancieraSeleccionada = 'No se ha seleccionado una plantilla de configuración financiera';
    public _noExisteFormasCobroSeleccionadas = 'No existe formas de cobro seleccionadas';
    public _noExisteDeudaAlumno = 'El alumno no tiene deuda';

    public _nombreServicio = 'Servicio Académico';
    public _numeroInstanciasMatricula = 'Número de Matrículas del Curso';
    
    // O
    public _oferta = 'Oferta';
    public _ofertaAsignaturasLibreEleccion = 'Oferta de Asignaturas de Libre Elección';
    public _ofertaAsignaturasEducacionFisica = 'Oferta de Asignaturas de Educación Física';
    public _ofertaAsignaturasIngles = 'Oferta de Asignaturas de Inglés';
    public _ofertaAsignaturasLibreEleccionGrupos = 'Oferta de Asignaturas de Libre Elección - Grupos';
    public _ofertaAsignaturasEducacionFisicaGrupos = 'Oferta de Asignaturas de Educación Física - Grupos';
    public _ofertaAsignaturasInglesGrupos = 'Oferta de Asignaturas de Inglés - Grupos';
    public _ofertaProceso = 'Oferta Proceso';
    public _orden = 'Orden';
    public _objetivo = 'Objetivo';
    public _otrosServicios = 'Otros Servicios';
    public _ofertasOtrosServicios = 'Ofertas Otros Servicios';
    public _ofertaOtrosServicios = 'Oferta Otros Servicios';
    public _ofertar = 'Ofertar';
    public _obligatorio = 'Obligatorio';
    public _ofertaAsignaturasEducacionContinua = 'Oferta de Asignaturas Educación Continua';
    public _ofertasIdiomas = 'Ofertas Idiomas';
    public _ofertasCursos = 'Ofertas de Cursos';
    public _observaciones = 'Observaciones';
    public _ordenCobro = 'Orden de Cobro';
    public _ofertasFinalizadas = 'Ofertas Finalizadas';
    // P
    public _planesFinanciamiento = 'Planes de Financiamiento';
    public _prerrequisito = 'Prerrequisito';
    public _prerrequisitos = 'Prerrequisitos';
    public _prerrequisitosNivel = 'Prerrequisitos por Nivel';
    public _periodo = 'Periodo'
    public _periodos = 'Periodos'
    public _periodoVigente = 'Periodo Vigente'
    public _preliminarGrupo = 'La distribución presentada es preeliminar. ' +
    'Una vez que se guarden los cambios se mostrará la distribución definitiva.';
    public _presioneEnterParaBuscar = '*Presione ENTER para buscar.';
    public _publicacionOfertas = 'Publicación de Ofertas';
    public _procesos = 'Procesos';

    public _parcial = 'Parcial';

    public _parametro = 'Parametro';

    public _prioridad = 'Prioridad';

    public _proceso = 'Proceso';
    public _porcentaje = 'Porcentaje';
    public _personas = 'Personas';
    public _personasProcesos = 'Personas Procesos';
    public _persona = 'Persona';
    public _papeletas = 'Papeletas';
    public _personasCobros = 'Personas en Cobros';
    public _plantillaConfiguracion = 'Plantilla de Configuración';
    public _plantillasConfiguracion = 'Plantillas de Configuración';
    public _plantillaProcesos = 'Plantillas de Procesos'
    public _porcentajeFaltasPerdida = 'Porcentaje Faltas Reprobado';
    public _plantillaConfiguracionFinanciera = 'Plantilla de Configuración Financiera';
    public _plantillasConfiguracionFinanciera = 'Plantillas de Configuración Financiera';
    public _pagar = 'Pagar';
    public _porcentajeInteres = 'Porcentaje Interes';
    public _porcentajeValor = 'Porcentaje/Valor';
    public _pagosVencidosUniversidadCuenca = 'Pagos Vencidos con la Universidad de Cuenca';
    public _tipoPlan = 'Créditos/Horas';

    // Q
    public _quitarFinalizacionOferta = 'Quitar la finalizacion de la oferta';
    public _tituloConfirmacion = 'Confirme:';
    public _quitarFinalizacion = 'Quitar Finalizacion';
    public _terminarOferta = 'Terminar Oferta';

    // R

    public _relacionAprendizaje = 'Relación de Aprendizaje';
    public _registros = 'Registros';
    public _registro = 'Registro';
    public _registroCalificaciones = 'Registro de Calificaciones';
    public _rubro = 'Rubro';
    public _resumenCalculosPregrado = 'Resumen de Cálculos de Pregrado';
    public _razonSocial = 'Razon Social';
    public _registrarConvenio = 'Registrar Convenio'
    public _ruc = 'R.U.C'
    public _recargo = 'Recargo';
    public _registrarDescuentoRecargo = 'Registrar Descuento/Recargo Específico';
    public _registrarConvenioMultiple = 'Registrar Convenio Multiple';
    public _registrarDescuentoMultiple = 'Registrar Descuento Multiple';    
    public _registrarDescuento = 'Registrar Descuento Recargo';
    public _rubros = 'Rubros';
    public _rechazar = 'RECHAZAR';
    public _reimpresionDocumentosEstudiante = 'Reimpresion de documentos de estudiante';
    public _registroAsignaturas = 'Registro de Asignaturas';
    public _registroCursosPosgrado = 'Registro de Cursos de Posgrado Habilitados para Oferta';
    public _roles='Roles';

    // S

    public _servicioExamenUbucacion = 'Servicio de Examen de ubicacion';
    public _seleccionar = 'Seleccionar';
    public _sede = 'Sede';
    public _si = 'Si';
    public _subtotal = 'Subtotal ($)';
    public _servicio = 'Servicio';
    public _servicioSeleccionado = 'Servicio Seleccionado';
    public _saldoFecha = 'Saldo a la Fecha';
    public _subprocesos = 'Subprocesos';
    public _subproceso = 'Subproceso';
    public _saldo = 'Saldo $';
    public _subir = 'Subir';
    public _subsuelo = 'Subsuelo';
    public _seleccionHorarioExamen = 'Seleccion de Horario de Examen';
    public _seleccionGrupoHorario = 'Seleccion de Grupos / Horarios';
    public _solicitarCambios = 'Solicitar Cambios';
    public _sistema = 'Sistema';
    public _sincronizarOrdenesERP = 'Sincronizar con OpenERP';

    // T
    public _tamanoArchivoGrande = 'El tamaño de archivo es muy grande.'; 
    public _tamanoMaximoArchivo = 'El tamaño máximo de archivo admitido es :';
    public _tipo = 'Tipo';
    public _tipoAsignatura = 'Tipo de Asignatura';
    public _total = 'Total ($)';
    public _totalCupos = 'Total';
    public _totalParcial = 'Total/Parcial';
    public _totalPagar = 'Total a Pagar ($)';
    public _tema = 'Tema(s)';
    public _tituloParametrosMatriculas = 'CONFIGURACIÓN DE PARÁMETROS DE FECHAS PARA MATRICULAS';
    public _tituloParametrosCalificaciones = 'CONFIGURACIÓN DE PARÁMETROS DE FECHAS PARA CALIFICACIONES';
    public _tituloParametrosOfertas = 'CONFIGURACIÓN DE PARÁMETROS DE FECHAS PARA OFERTAS';
    public _tituloParametrosFichaSocioEconomica = 'CONFIGURACIÓN DE PARÁMETROS DE FECHAS PARA REGISTRO DE FICHA SOCIO-ECONÓMICA';
    public _tipoMatricula = 'Tipo de Matrícula';
    public _tipoMatriculasParametroLabel = 'Tipo de Matrícula';
    public _tipoOtroServicio = 'Tipo Servicio';
    public _tipoValor = 'Tipo Valor';
    public _tipoRegistro = 'Tipo Registro';
    public _totalAlumnoPagar = 'Total Estudiante Pagar';
    public _totalOriginal = 'Total Original $';
    public _totalDescuento = 'Total Descuento $';
    public _totalRecargos = 'Total Recargos $';
    public _totalPagar1 = 'Total Pagar $';
    public _tipoUnidad = 'Tipo Unidad';
    public _tipoIdentificacion = 'Tipo de Identificación';
    public _telefono = 'Teléfono';
    public _totalNeto = 'Total Neto $';
    public _tituloCargaArchivoOferta = 'Documento para respaldo de oferta gratuita';
    public _tituloCargaArchivoDescuentoRecargoXRubro = 'Documento para respaldo de descuento manual';
    public _tipoSubproceso = 'Tipo Subproceso';

    // U
    public _unidad = 'Unidad';
    public _unidadNoSeleccionada = 'Unidad no seleccionada';
    public _unidadOferta = 'Unidad que oferta';
    public _unidadListarOfertas = 'UNIDAD PARA LISTAR SUS OFERTAS';

    // V
    public _validar = 'Validar';
    public _valor = 'Valor';
    public _valor1 = 'Valor 1';
    public _valor2 = 'Valor 2';
    public _volver = 'Regresar';
    public _vigente = 'Vigente';
    public _valorAporte = 'Calificación del registro';
    public _ver = 'Ver';
    public _verInformacion = 'Ver Informacion';
    public _verEstudiantes = 'Ver Estudiantes';
    public _verAlumnos = 'Ver Estudiantes';
    public _verCalificaciones = 'Ver Calificaciones';
    public _verFicha = 'Ver Ficha';
    public _volverOferta = 'Volver a Oferta';
    public _visibleSecretaria = 'Visible para la secretaria';
    public _visibleAlumno = 'Visible para el alumno';
    public _valorDeuda = 'Valor Deuda';
    public _volverNiveles = 'Volver a niveles';
    //


    public _VAR_NUMERO_FILAS_TABLA = '15';













}
